import { supabase } from "@/integrations/supabase/client";

export async function getMyRoles(): Promise<string[]> {
  // Fetch from user_roles table via RPC
  const { data, error } = await supabase.rpc("current_user_roles");

  let userRoles: string[] = [];
  if (error) {
    console.error("[roles] current_user_roles RPC failed:", error);
  } else {
    userRoles = (data ?? []).map((r: any) => {
      const role = r.role || r;
      return role === "super_admin" ? "admin" : role;
    }).filter(Boolean);
  }

  // Also fetch sub_org_memberships roles (for portfolio_manager)
  const { data: somData, error: somErr } = await (supabase as any).rpc("current_user_sub_org_roles");
  if (!somErr && Array.isArray(somData)) {
    const somRoles = somData.map((r: any) => (typeof r === "string" ? r : r.role)).filter(Boolean);
    userRoles = [...userRoles, ...somRoles];
  }

  // Dedupe and return
  return Array.from(new Set(userRoles));
}

export async function getMySubOrgRoles(): Promise<Array<{ sub_org_id: string; role: string }>> {
  const { data, error } = await (supabase as any).rpc("current_user_sub_org_roles");
  if (error) {
    console.error("[roles] current_user_sub_org_roles failed:", error);
    return [];
  }
  return (data ?? []) as any;
}

export async function isAdmin(): Promise<boolean> {
  const roles = await getMyRoles();
  return roles.includes("admin");
}